import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import en from "./locales/en.json";
import es from "./locales/es.json";

export const LANGUAGE_STORAGE_KEY = "consultalex.language";
export const LANGUAGE_EXPLICIT_STORAGE_KEY = "consultalex.language.explicit";
export const SUPPORTED_LANGUAGES = ["es", "en"] as const;

export type AppLanguage = (typeof SUPPORTED_LANGUAGES)[number];

export const toAppLanguage = (language?: string): AppLanguage =>
  language?.toLowerCase().startsWith("en") ? "en" : "es";

const updateDocumentLanguage = (language: string) => {
  if (typeof document !== "undefined") {
    document.documentElement.lang = toAppLanguage(language);
  }
};

const ensureSpanishDefaultLanguage = () => {
  if (typeof window === "undefined") return;

  const hasExplicitLanguage =
    window.localStorage.getItem(LANGUAGE_EXPLICIT_STORAGE_KEY) === "true";

  if (!hasExplicitLanguage) {
    window.localStorage.setItem(LANGUAGE_STORAGE_KEY, "es");
  }
};

ensureSpanishDefaultLanguage();

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      es: { translation: es },
    },
    fallbackLng: "es",
    supportedLngs: SUPPORTED_LANGUAGES,
    load: "languageOnly",
    initImmediate: false,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ["localStorage"],
      lookupLocalStorage: LANGUAGE_STORAGE_KEY,
      caches: ["localStorage"],
    },
    react: {
      useSuspense: false,
    },
  });

i18n.on("languageChanged", updateDocumentLanguage);
updateDocumentLanguage(i18n.resolvedLanguage || i18n.language);

export default i18n;
